import React, { Component, Fragment } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { Layout as AppLayout } from "antd";
import LangContext, { i18n } from "modules/shared/context/langContext";
import PrivateRoute from "./PrivateRoute";
import Header from "./Header";
import SliderBar from "./SliderBar";

import * as authActions from "modules/auth/actions";
import * as uiActions from "modules/ui/actions";

import Login from "modules/auth/components/Login";

import { ListMenu } from "./ListMenu";
import ContentLayout from "./ContentLayout";

class Layout extends Component {
  state = {
    collapsed: true,
    i18n: i18n.th,
    langBtn: "th",
    checkSelectLang: "",
    url: "",
  };

  changeLang = (inputLng) => {
    this.setState({
      i18n: i18n[inputLng],
      langBtn: inputLng,
    });
    this.props.changeLanguage(inputLng);
  };

  setMsg = (title, msg) => this.props.setFlashMessage(title, msg);

  onRemoveCredentials = () => {
    this.props.removeCredentials();
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  componentDidMount() {
    this.props.loadCredentials();
  }

  render() {
    window.collapsedLayout = this.state.collapsed;
    return (
      <Router>
        <Fragment>
          {this.props.done !== true ? (
              <Login auth={this.props.path} />
          ) : (
            <LangContext.Provider value={this.state.i18n}>
              <AppLayout>
                <SliderBar
                  collapsed={this.state.collapsed}
                  toggle={this.toggle}
                  profile={this.props.profile}
                />
                <AppLayout
                  style={{
                    minHeight: `${window.innerHeight - 100}px`,
                  }}
                >
                  <Header
                    collapsed={this.state.collapsed}
                    toggle={this.toggle}
                    langBtn={this.state.langBtn}
                    changeLang={this.changeLang}
                    checkSelectLang={this.state.checkSelectLang}
                  />
                  <ContentLayout>
                    {ListMenu.map((v, k) => {
                      return (
                        <PrivateRoute
                          key={k}
                          value={v}
                          done={this.props.done}
                          profile={this.props.profile}
                        />
                      );
                    })}
                  </ContentLayout>
                </AppLayout>
              </AppLayout>
            </LangContext.Provider>
          )}
        </Fragment>
      </Router>
    );
  }
}

const mapStateToProps = ({
  auth,
  auth: { accessToken, done, profile, tokenExp },
  ui: { flash, langBtn },
}) => ({
  auth,
  accessToken,
  done,
  profile,
  flash,
  tokenExp,
  langBtn,
});

const mapDispatchToProps = {
  removeCredentials: authActions.removeCredentials,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: uiActions.clearFlashMessage,
  setFlashMessage: uiActions.setFlashMessage,
  changeLanguage: uiActions.changeLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
